import { useContext } from 'react';

import { StylesProviderContext } from './index';

const useAppStyles = () => {
	return useContext(StylesProviderContext);
};

export default useAppStyles;
